import React from 'react';
import { MessageCircleIcon } from 'lucide-react';
import { WHATSAPP_URL } from './Shared';
export function Footer() {
  return <footer className="footer" data-id="element-33">
      <div className="footer-wordmark" data-id="element-34">ARMONY</div>

      <p className="footer-disclaimer" data-id="element-35">
        A.R.M.O.N.Y. es un recurso educativo. No constituye asesoría médica,
        diagnóstico o tratamiento. Consulta siempre con profesionales médicos
        certificados antes de tomar decisiones sobre tu cuerpo. Los resultados
        individuales varían según cada caso.
      </p>

      <p className="footer-copyright" data-id="element-36">
        {'© Dermaclinic Method · Miami · Los\u00A0Angeles · New\u00A0York · Las\u00A0Vegas · Phoenix · Houston'}
      </p>

      <div className="footer-email" data-id="element-37">
        <span className="footer-email-label" data-id="element-38">Atención al cliente</span>
        <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" data-cta="footer_whatsapp" className="footer-whatsapp-btn" data-id="element-39">
          <MessageCircleIcon size={14} strokeWidth={1.75} aria-hidden="true" data-id="element-40" />
          WhatsApp · +1 (332) 281-7703
        </a>
        <a href="mailto:info@dermaclinicenter.com" data-id="element-41">info@dermaclinicenter.com</a>
      </div>

      <p className="footer-links" data-id="element-42">
        <a href="https://shop.dermaclinicenter.com/policies/refund-policy" target="_blank" rel="noopener noreferrer" data-id="element-43">
          Reembolso
        </a>
        <span className="sep" data-id="element-44">·</span>
        <a href="https://shop.dermaclinicenter.com/policies/privacy-policy" target="_blank" rel="noopener noreferrer" data-id="element-45">
          Privacidad
        </a>
        <span className="sep" data-id="element-46">·</span>
        <a href="https://shop.dermaclinicenter.com/policies/terms-of-service" target="_blank" rel="noopener noreferrer" data-id="element-47">
          Términos
        </a>
      </p>
    </footer>;
}